define([
	"csi",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(csi, Action, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("New", Action, {
		// String: name of relationship to which to add new node (by default will be picked up from Relationship tag)
		//idRelation: null,

		// String: default tag for action
		m_tag: "New",

		// String: type of node to create (required)
		m_typeNode: null,

		constructor: function(obj) {
			this.m_typeNode = util.getProperty(obj, 'Type');
			this.idRelation = util.getProperty(obj, 'RelationId');

			// set defaults for action if not explicitly configured
			this.m_id = this.m_id || (this.m_tag + this.m_typeNode);

			this.assignFormIfNecessary(util.getProperty(obj, "Form"));

			// allow parent right to be empty in rare cases
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: if the type of Node is known, make sure it's not abstract
			var rc = reflection.getClass(this.m_typeNode);
			return rc?.enabled && this.inherited(arguments);
		},

		isValid: function() {
			return this.m_typeNode && this.inherited(arguments);
		},

		toHtml: function(/*Context*/ctx, /*DOMNode*/refNode, /*Boolean*/bRenderDisabled, /*Boolean*/bForceDisabled) {
			// summary: if action has node context, then switch to parent
			var res = null;
			var bPop = false;

			if (!ctx) {
				// handle special cases with page actions outside any view
				res = this.toHtmlWithAccess(ctx, refNode);
			} else {
				if (ctx.push(this.m_path)) {
					// if New action is used within Relationship/Actions then relation to new node is unknown (and may not even exist)
					if (this._needToSwitchContextToParent(ctx)) {
						ctx.pushParams({
							idRelation: this.idRelation,
							urlNode: csi.EMPTY_URL,
							urlParent: ctx.getNodeURL()
						});

						bPop = true;
					}

					if (!bForceDisabled && this.hasAccess(ctx)) {
						res = this.toHtmlWithAccess(ctx, refNode);
					}

					// if no access to action and want to render disabled actions, then do so now
					if (!res && bRenderDisabled) {
						res = this.toHtmlWithoutAccess(ctx, refNode);
					}

					if (bPop) {
						ctx.pop();
					}

					ctx.pop();
				}
			}

			return res;
		},

		validate: function(/*Context*/ctx) {
			// summary: allow action if class exists for configured type
			return reflection.getClass(this.m_typeNode) && this.inherited(arguments);
		},

		_needToSwitchContextToParent: function(/*def.Context*/ctx) {
			return !!ctx.getNode();
		},

		_getNameParams: function(/*csi.LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			return [lr.getTypeName(this.m_typeNode)];
		}
	});
});